import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey:            "AIzaSyDT6Zf9ULua1Ob6LwychAwb0JGIFUlIWvs",
  authDomain:        "shuttlecock-4cf32.firebaseapp.com",
  projectId:         "shuttlecock-4cf32",
  storageBucket:     "shuttlecock-4cf32.firebasestorage.app",
  messagingSenderId: "356293306155",
  appId:             "1:356293306155:web:c413d9e48bc7569fc3476e",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);